__webpack_require__.p = "https://pwd.balurghatmnc.in/";